import React from "react";
import ExclamationIcon from "../../assets/img/exclamation-mark-icon.svg";
const TenureAlertPopUp = React.forwardRef((props, ref) => {
  const { showModalBox, record, title, description, isAdd, checkStatus } =
    props;

  const closePopupHandler = () => {
    props.closePopup();
  };

  const proceedHandler = (e) => {
    e.preventDefault();
    props.proceedHandler();
  };

  console.log("des", description);
  return (
    <>
      <div
        className={
          "dashboard custom-modal-dialog " +
          (showModalBox === 1 ? "show" : "hidden")
        }
        onClick={closePopupHandler}
      >
        <div
          className="modal-wrapper"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <div
            className="modal-content p-4 no-scroll"
            style={{ maxWidth: "370px" }}
          >
            <div className="text-left">
              <img src={ExclamationIcon} alt="" />
              <h5 className="mt-3">{title}</h5>
              <p className="text-muted">{description}</p>
            </div>
            <div className="row">
              <div className="col-md-12 d-flex justify-content-between">
                <button
                  className="btn btn-outline-secondary btn-lg btn-block mt-3 mr-2"
                  onClick={closePopupHandler}
                >
                  Go back & edit
                </button>
                <button
                  className={
                    isAdd
                      ? "btn btn-success btn-lg btn-block mt-3"
                      : "btn btn-danger btn-lg btn-block mt-3"
                  }
                  onClick={
                    checkStatus != 1
                      ? (e) => proceedHandler(e)
                      : (e) => closePopupHandler(e)
                  }
                >
                  Confirm & Proceed
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
});

export default TenureAlertPopUp;
